module.exports = __webpack_public_path__ + "static/media/dropbox_icon.c0544952.png";